import React from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/" className="text-primary text-2xl font-bold">
                راكان الجعفري
              </Link>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8 sm:space-x-reverse">
              <Link to="/" className="border-transparent text-gray-900 hover:text-primary inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
                الرئيسية
              </Link>
              <Link to="/services" className="border-transparent text-gray-500 hover:text-primary inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
                خدماتي
              </Link>
              <Link to="/barkar-projects" className="border-transparent text-gray-500 hover:text-primary inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
                مشروع بركار
              </Link>
              <Link to="/rakan-box" className="border-transparent text-gray-500 hover:text-primary inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
                الصندوق الراكاني
              </Link>
              <Link to="/side-projects" className="border-transparent text-gray-500 hover:text-primary inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
                أعمالي الجانبية
              </Link>
              <Link to="/contact" className="border-transparent text-gray-500 hover:text-primary inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
                تواصل معي
              </Link>
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            <Link to="/book-consultation" className="bg-primary text-white hover:bg-primary-dark px-4 py-2 rounded-md text-sm font-medium transition duration-300">
              حجز استشارة
            </Link>
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
            >
              <span className="sr-only">فتح القائمة الرئيسية</span>
              {isOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="sm:hidden">
          <div className="pt-2 pb-3 space-y-1">
            <Link to="/" className="bg-primary-light text-primary block pl-3 pr-4 py-2 border-r-4 border-primary text-base font-medium" onClick={() => setIsOpen(false)}>
              الرئيسية
            </Link>
            <Link to="/services" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-r-4 text-base font-medium" onClick={() => setIsOpen(false)}>
              خدماتي
            </Link>
            <Link to="/barkar-projects" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-r-4 text-base font-medium" onClick={() => setIsOpen(false)}>
              مشروع بركار
            </Link>
            <Link to="/rakan-box" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-r-4 text-base font-medium" onClick={() => setIsOpen(false)}>
              الصندوق الراكاني
            </Link>
            <Link to="/side-projects" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-r-4 text-base font-medium" onClick={() => setIsOpen(false)}>
              أعمالي الجانبية
            </Link>
            <Link to="/contact" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-r-4 text-base font-medium" onClick={() => setIsOpen(false)}>
              تواصل معي
            </Link>
            <Link to="/book-consultation" className="bg-primary text-white block text-center mx-4 my-2 px-4 py-2 rounded-md text-base font-medium transition duration-300" onClick={() => setIsOpen(false)}>
              حجز استشارة
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
